export enum MatchStatus {
	Fixture = 'Fixture',
	Played = 'Played',
	Playing = 'Playing',
	Cancelled = 'Cancelled',
	Postponed = 'Postponed',
	Suspended = 'Suspended',
	All = 'All',
}
